import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home/HomePage.vue'),
      meta: {
        activedIndex: 0,
      },
    },
    {
      path: '/homepage',
      name: 'homepage',
      redirect: { name: 'home' },
    },
    {
      path: '/home/brandList',
      name: 'homepage-brandlist',
      component: () => import('./views/home/BrandList.vue'),
      meta: {
        title: '品牌列表',
        activedIndex: 0,
      },
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('./views/Error.vue'),
      meta: {
        title: '錯誤',
        activedIndex: 0,
      },
    },
    {
      path: '/weeklyHot',
      name: 'weeklyHot',
      component: () => import('./views/home/WeeklyHot.vue'),
      meta: {
        title: '本週熱賣',
        activedIndex: 0,
      },
    },
    {
      path: '/BannerList',
      name: 'bannerList',
      component: () => import('./views/home/BannerList.vue'),
      meta: {
        title: 'Banner列表',
        activedIndex: 0,
      },
    },
    {
      path: '/category/:id',
      name: 'category',
      component: () => import('./views/category/CategoryPage.vue'),
      meta: {
        activedIndex: 0,
      },
    },
    {
      path: '/selfBuildCategory/:id',
      name: 'selfBuildCategory',
      component: () => import('./views/category/SelfBuildCategoryPage.vue'),
      meta: {
        activedIndex: 0,
      },
    },
    {
      path: '/product/:id',
      name: 'product',
      component: () => import('./views/product/ProductPage.vue'),
      meta: {
        activedIndex: -1,
      },
    },
    {
      path: '/curation/:id',
      name: 'curation',
      component: () => import('./views/curation/CurationPage.vue'),
      meta: {
        activedIndex: 0,
      },
    },
    {
      path: '/payment/userInfo',
      name: 'paymentInfo',
      component: () => import('./views/payment/PaymentInfoPage.vue'),
      meta: {
        title: '購買資訊',
        activedIndex: 0,
      },
    },
    {
      path: '/payment/pay',
      name: 'paymentPay',
      component: () => import('./views/payment/PaymentPayPage.vue'),
      meta: {
        title: '付款方式',
        activedIndex: 0,
      },
    },
    {
      path: '/payment/result/:status',
      name: 'paymentResult',
      component: () => import('./views/payment/PaymentResultPage.vue'),
      meta: {
        title: '付款結果',
        activedIndex: 0,
      },
    },
    {
      path: '/order/TICKET',
      name: 'orderListTicket',
      props: { orderType: 'TICKET' },
      component: () => import('./views/order/OrderListPage.vue'),
      meta: {
        title: '電子票券購買清單',
        activedIndex: 2,
      },
    },
    {
      path: '/order/GOODS',
      name: 'orderListGoods',
      props: { orderType: 'GOODS' },
      component: () => import('./views/order/OrderListPage.vue'),
      meta: {
        title: '宅配商品購買清單',
        activedIndex: 3,
      },
    },
    {
      path: '/order/COFFEE',
      name: 'orderListCoffee',
      props: { orderType: 'COFFEE' },
      component: () => import('./views/order/OrderListPage.vue'),
      meta: {
        title: '咖啡寄杯',
        activedIndex: 2,
      },
    },
    {
      path: '/orderDetail/:oid/:lastServiceNo?/:nOid?',
      name: 'orderDetail',
      component: () => import('./views/order/OrderDetailPage.vue'),
      meta: {
        title: '訂單明細',
        activedIndex: -1,
        passTitleCheck: true,
      },
    },
    {
      path: '/redeem/:amount',
      name: 'redeem',
      component: () => import('./views/order/RedeemPage.vue'),
      meta: {
        title: '開啟條碼',
        activedIndex: -1,
      },
    },
    {
      path: '/customerService/:type?',
      name: 'customerServicePage',
      component: () => import('./views/CustomerServicePage.vue'),
      meta: {
        title: '客服中心',
        activedIndex: 4,
      },
    },
    {
      path: '/contactCustomerService/:questionType/:orderNo',
      name: 'contactCustomerServicePage',
      component: () => import('./views/ContactCustomerServicePage.vue'),
      meta: {
        title: '聯絡客服',
        activedIndex: -1,
      },
    },
    {
      path: '/externalLink',
      name: 'externalLink',
      component: () => import('./views/ExternalLinkPage.vue'),
    },
    {
      path: '/serviceAsking/:type/:serviceNo',
      name: 'serviceAskingPage',
      component: () => import('./views/ServiceAskingPage.vue'),
      meta: {
        title: '聯絡客服',
        activedIndex: -1,
      },
    },
    {
      path: '/Maintenance',
      name: 'Maintenance',
      component: () => import('./views/MaintenancePage.vue'),
      meta: {
        title: '維護公告',
      },
    },
    // {
    //   path: '/paymentReturn/:type',
    //   name: 'paymentReturn',
    //   component: () => import('./views/return/PaymentReturn.vue'),
    //   meta: {
    //     title: '退貨',
    //   },
    // },
    {
      path: '/return/reason',
      name: 'returnReason',
      component: () => import('./views/return/returnReason.vue'),
      meta: {
        title: '退貨',
      },
    },
    {
      path: '/return/policy',
      name: 'returnPolicy',
      component: () => import('./views/return/returnPolicy.vue'),
      meta: {
        title: '退貨',
      },
    },
    {
      path: '/return/atm',
      name: 'returnAtm',
      component: () => import('./views/return/returnAtm.vue'),
      meta: {
        title: '退貨',
      },
    },
    {
      path: '/return/result',
      name: 'returnResult',
      component: () => import('./views/return/returnResult.vue'),
      meta: {
        title: '退貨',
      },
    },
    {
      path: '/guideline',
      name: 'GuideLine',
      component: () => import('./views/serviceLink/guideline.vue'),
      meta: {
        title: '使用規範',
        activedIndex: 0,
      },
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import('./views/serviceLink/privacy.vue'),
      meta: {
        title: '隱私權政策',
        activedIndex: 0,
      },
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('./views/search/Search.vue'),
      meta: {
        title: '搜尋',
        activedIndex: 1,
      },
    },
    {
      path: '/searchResult',
      name: 'searchResult',
      component: () => import('./views/search/SearchResult.vue'),
      meta: {
        title: '搜尋結果',
        activedIndex: 1,
      },
    },
    {
      path: '/pioauthback',
      name: 'pioauthback',
      component: () => import('./views/pioauthback.vue'),
      meta: {
        title: '',
        activedIndex: -1,
      },
    },
    {
      path: '/collectionList',
      name: 'collectionList',
      component: () => import('./views/home/CollectionList.vue'),
      meta: {
        title: '我的最愛',
        activedIndex: 0,
      },
    },
    {
      path: '/Maintenance',
      name: 'Maintenance',
      component: () => import('./views/MaintenancePage.vue'),
      meta: {
        title: '維護公告',
      },
    },
  ],
})
